import {ExclamationIcon} from '@primer/octicons-react'
import {SkeletonBox} from '@primer/react/experimental'
import {ForYouItemPresentation} from './ForYouItem'

/**
 * Skeleton placeholder rendered while a ForYouItem's async content loads.
 * Mirrors the collapsed-header shape of ForYouItem so the layout is stable.
 */
export function ForYouItemSkeleton({text, actionWidth}: {text?: string; actionWidth?: string}) {
  return (
    <ForYouItemPresentation
      itemId="loading"
      visual={{kind: 'skeleton'}}
      title={text ?? 'Loading item'}
      actions={
        actionWidth ? [{id: 'loading-action', content: <SkeletonBox width={actionWidth} height="28px" />}] : undefined
      }
    />
  )
}

/**
 * Error state rendered when a ForYouItem's content throws.
 * Matches the collapsed-header shape so the list layout is preserved.
 */
export function ForYouItemError() {
  return (
    <ForYouItemPresentation
      itemId="error"
      visual={{kind: 'icon', icon: ExclamationIcon, tone: 'danger', glyphSize: 12}}
      title="Unable to load this item"
      subText="Try reloading the page."
    />
  )
}
